import React from "react";
import Types from "prop-types";
import { ReCaptcha } from "../../Guard";
import { Helmet } from "react-helmet";
import { withTranslation } from "react-i18next";
import eventAnalytics from "../../../analytikaV2";
import { ANALYTIKA_EVENTS } from "../../../utils/constants";
import { loadSheild } from "../../../sheild";

export class MerchantSignupForm extends React.Component {
  constructor(props) {
    super(props);
    loadSheild();
    eventAnalytics.setPageName(ANALYTIKA_EVENTS.PAGE.SIGNUP_FORM);
    eventAnalytics.publishV2(
      ANALYTIKA_EVENTS.IDNW_VIEW_PAGE,
      {
        page_name: "merchant_signup_form",
      }
    );
  }

  render() {
    const { t, error, submitting, email, fullName, password } = this.props;
    return (
      <form onSubmit={this.props.onSubmit}>
        <Helmet>
          <title>Sign up | Careem</title>
        </Helmet>

        <h1 className="heading-h1-express center express-common">
          {t("signup:merchant_title")}
        </h1>

        <p className="express-extra-text show express-common center">
          {t("signup:merchant_subtitle")}
        </p>

        {error && <div className="invalid show">{error}</div>}

        <div className="material-form-field">
          <input
            type="email"
            autoComplete="off"
            id="email"
            name="email"
            value={email}
            readOnly
          />
          <label className="material-form-field-label" htmlFor="email">
            {t("signup:email")}
          </label>
        </div>

        <div className="material-form-field">
          <input
            type="text"
            autoFocus
            autoComplete="off"
            id="fullname"
            name="fullname"
            required
            onChange={this.props.onFullNameChange}
            value={fullName}
          />
          <label className="material-form-field-label" htmlFor="fullname">
            {t("signup:full_name")}
          </label>
        </div>

        <div className="material-form-field">
          <input
            autoComplete="off"
            type="password"
            id="password"
            name="password"
            required
            minLength={6}
            onChange={this.props.onPasswordChange}
            value={password}
          />
          <label className="material-form-field-label" htmlFor="password">
            {t("signup:password")}
          </label>
        </div>
        <div className="express-extra-text show">
          {t("signup:password_placeholder")}
        </div>

        <input
          className="btn-express btn-express-primary"
          type="submit"
          value={submitting ? t("common:please_wait") : t("signup:button")}
          name="merchant-signup-btn"
          disabled={
            submitting ||
            !fullName ||
            fullName.length === 0 ||
            !password ||
            password.length < 6
          }
        />

        <ReCaptcha />
      </form>
    );
  }
}

MerchantSignupForm.propTypes = {
  t: Types.func.isRequired,
  error: Types.any,
  submitting: Types.bool.isRequired,
  email: Types.string.isRequired,
  fullName: Types.string.isRequired,
  password: Types.string.isRequired,
  onFullNameChange: Types.func.isRequired,
  onPasswordChange: Types.func.isRequired,
  onSubmit: Types.func.isRequired,
};

export default withTranslation()(MerchantSignupForm);
